import {Card, Col, Row, Timeline} from "antd";
import React, {ComponentProps, useEffect, useState} from "react";
import {useRequest} from "ahooks";
import * as api from "../../../apis/salesOrder";
import dayjs from "dayjs";

type ExpressTabProps = ComponentProps<any> & {
    record: any
}

function ExpressTab(props: ExpressTabProps) {

    const record = props.record
    const [expresses, setExpresses] = useState<Array<any>>([])

    useEffect(() => {
        if (record) {
            run(record.id)
        }
    }, [record])

    const {loading, run} = useRequest(api.getOrderExpress, {
        manual: true,
        onSuccess: (res) => {
            res.data.data.forEach((item: any) => {
                item.expressRouter = item.expressRouter && item.expressRouter.map((i: any) => {
                    return {
                        children: `${i.acceptTime} ${i.acceptAddress} ${i.remark}`
                    }
                })
            })
            setExpresses(res.data.data)
            debugger
        }
    })

    return (
        <div>
            {expresses.map((item: any) => (
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        borderColor: 'rgba(5, 5, 5, 0.06)'
                    }}
                    border={1}
                    cellSpacing={0} cellPadding={0}>
                    <thead>
                    <tr style={{height: 40, textAlign: "center", backgroundColor: 'rgba(0, 0, 0, 0.02)'}}>
                        <td width={'10%'} style={{fontWeight: "bold"}}>运输方式</td>
                        <td width={'20%'}>{item.expressName}</td>
                        <td width={'10%'} style={{fontWeight: "bold"}}>快递单号</td>
                        <td width={'20%'}>{item.expressNo}</td>
                        <td width={'10%'} style={{fontWeight: "bold"}}>发货日期</td>
                        <td width={'20%'}>{dayjs(item.deliveryDate).format('ll')}</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colSpan={6} style={{padding: '50px 0 0 50px'}}>
                            <Timeline
                                items={item.expressRouter}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            ))}
        </div>
    )
}

export default ExpressTab;